import useAxiosCall from './useAxiosCall';
import { useNotification } from '../Context/NotificationContext';
import { useDomain } from '../Context/DomainContext';
import { decryptData, encryptData } from '../Utilities/CryptoUtility';
const useNotifications = () => {
    const { makeApiCall } = useAxiosCall();
    const { domain: contextDomain } = useDomain();
    const { setNotifications, notificationsFetch, setNotificationsFetch } = useNotification();

    const handleApiCallSuccess = (data, page) => {
        let decryptedData = decryptData(data.data);
        if (page == 1) {
            setNotifications(decryptedData.notifications.data)
        } else {
            setNotifications((currentNotifications) => currentNotifications.concat(decryptedData.notifications.data));
        }    
        if (decryptedData.notifications.to == decryptedData.notifications.total || decryptedData.notifications.data.length == 0) {
            setNotificationsFetch(false)
        }
    };

    const handleApiCallError = (errorMessage) => {
        console.error('Error fetching notifications:', errorMessage);
    };

    const fetchNotifications = async (page=1, force = false, domainOverride) => {
        if (notificationsFetch == true || force == true ) {
            try {
                const domain = domainOverride != null ? String(domainOverride) : contextDomain;
                if (!domain) {
                    console.warn('fetchNotifications: domain not available, skipping');
                    return;
                }
                const requestData = {
                    data: encryptData(JSON.stringify(
                        {
                            domain,
                            page:page
                        }
                    ))
                };

                await makeApiCall({
                    requestData,
                    url: 'getNotifications',
                    requestType: 'POST',
                    onSuccess: (data) => handleApiCallSuccess(data, page),
                    onError: handleApiCallError,
                    loader:false
                });

            } catch (error) {
                console.error('Error fetching notifications:', error);;
            }
        }
    };

    return { fetchNotifications };
};

export default useNotifications;
